import { useState } from "react";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../redux/slice/system";
import { useAbortedEffect } from "../../components/hooks";
import { CommonAPI } from "../../axios/api";

import ModuleChartSingleView from "../../components/chartSingleView";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";

export default function ModulePopDiagram({
  popPreOption,
  closePrePop,
  systemWeb,
}) {
  const dispatch = useDispatch();

  return (
    <>
      <div className="mx-3">
        {popPreOption.data && (
          <ModuleChartSingleView
            systemWeb={systemWeb}
            moduleData={popPreOption.data}
          />
        )}

        <div className="text-center mt-3">
          <Button
            className="p-button-secondary px-3"
            type="button"
            label="關閉"
            onClick={() => closePrePop({ type: "view" })}
          />
        </div>
      </div>
    </>
  );
}
